export default "__VITE_ASSET__L3MV5E6p__"